import { render, staticRenderFns } from "./CaseFormSource.vue?vue&type=template&id=1371bfbc&scoped=true&"
import script from "./CaseFormSource.vue?vue&type=script&lang=ts&"
export * from "./CaseFormSource.vue?vue&type=script&lang=ts&"
import style0 from "./CaseFormSource.vue?vue&type=style&index=0&id=1371bfbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1371bfbc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
